import React, { useState } from 'react'
import { Tooltip, IconButton, Dialog } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import DialogView from '../../../Dialogos/DialogView'
import EdicionCalleDeCalado from './EdicionCalleDeCalado'
import { updateCalleDeCalado } from '../../actions'
import { formValueSelector, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { FORM_CALLE_DE_CALADO } from '../../../../config/forms'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'

function OperacionesCallesDeCalado (props) {
  const { calle, updateCalleDeCalado, numero, cerealAsignado, capacidadCalle, habilitado } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleUpdate = () => {
    updateCalleDeCalado(numero, cerealAsignado, capacidadCalle, habilitado)
    handleClose()
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='xl'
        fullWidth
      >
        <DialogView
          cancelCallback={handleClose}
          confirmCallback={handleUpdate}
          title='Editar calle de calado'
          content={<EdicionCalleDeCalado calle={calle} />}
        />
      </Dialog>
      <Tooltip title='Editar'>
        <IconButton onClick={handleOpen} style={{ outline: 'none' }}>
          <EditIcon />
        </IconButton>

      </Tooltip>
    </>
  )
}

const selector = formValueSelector(FORM_CALLE_DE_CALADO)

const mapStateToProps = (state) => ({
  numero: selector(state, 'numero'),
  capacidadCalle: selector(state, 'capacidadCalle'),
  cerealAsignado: selector(state, 'cereal'),
  habilitado: selector(state, 'habilitado')
})

const mapActionsToProps = ({
  updateCalleDeCalado
})

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_CALLE_DE_CALADO
})

export default withRedux(withReduxForm(OperacionesCallesDeCalado))
